import { CodeBlockLowlight } from '@tiptap/extension-code-block-lowlight';
import Link from '@tiptap/extension-link';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import type { Extensions } from '@tiptap/core';
import { common, createLowlight } from 'lowlight';
import ImageResize from 'tiptap-extension-resize-image';

interface TipTapProps {
  extensions: Extensions;
  editorProps: {
    attributes: {
      class: string;
    };
  };
}

export function getTipTapProps(): TipTapProps {
  const lowlight = createLowlight(common);
  lowlight.register(common);
  const extensions = [
    StarterKit.configure({
      codeBlock: false,
      heading: {
        levels: [1, 2, 3],
        HTMLAttributes: {
          class: 'text-gray-dark-12',
        },
      },
      bulletList: {
        keepMarks: true,
        keepAttributes: true,
        HTMLAttributes: {
          class: 'list-disc ml-6 space-y-1',
        },
      },
      orderedList: {
        keepMarks: true,
        keepAttributes: true,
        HTMLAttributes: {
          class: 'list-decimal ml-6 space-y-1 [&_::marker]:text-sm',
        },
      },
      blockquote: {
        HTMLAttributes: {
          class:
            'border-l-4 border-gray-dark-6 bg-gray-dark-1 p-3 my-2 rounded',
        },
      },
      horizontalRule: {
        HTMLAttributes: {
          class: 'border-b border-gray-dark-6 !my-4',
        },
      },
      code: {
        HTMLAttributes: {
          class:
            'bg-gray-dark-5 text-gray-dark-12 rounded px-1.5 py-0.5 text-sm font-mono',
        },
      },
    }),
    Underline.configure({
      HTMLAttributes: { class: 'text-underline' },
    }),
    CodeBlockLowlight.configure({
      lowlight,
      HTMLAttributes: {
        class: 'bg-gray-dark-1 text-gray-dark-12 rounded p-3 my-2 text-sm',
      },
    }),
    ImageResize.configure({
      inline: true,
      HTMLAttributes: {
        class: 'w-full object-cover object-center',
      },
    }),
    Link.configure({
      HTMLAttributes: {
        class:
          'relative z-10 text-mint-dark-9 font-semibold decoration-mint-dark-9 hover:underline hover:decoration-solid hover:text-mint-dark-11 hover:cursor-pointer transition-colors',
        rel: 'noopener noreferrer nofollow',
        target: '_blank',
      },
      openOnClick: true,
      linkOnPaste: true,
      autolink: true,
    }),
  ];

  const editorProps = {
    attributes: {
      class: 'border-none text-gray-dark-11 rounded border outline-none h-full',
    },
  };

  return { extensions, editorProps };
}
